// src/components/ProblemViewComponents/ProgressInfoBar.tsx

import React from 'react';
import { Box, Typography, LinearProgress, Paper } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface ProgressInfoBarProps {
  message: string;
  isProcessing: boolean;
  show: boolean;
}

const ProgressInfoBar: React.FC<ProgressInfoBarProps> = ({ message, isProcessing, show }) => {
  if (!show) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        width: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
        mb: 3,
        borderRadius: 1,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {isProcessing && (
        <LinearProgress
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '2px',
            backgroundColor: 'transparent',
          }}
        />
      )}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          px: 2,
          py: 1.5,
          gap: 1,
        }}
      >
        <InfoOutlinedIcon
          sx={{
            color: 'text.secondary',
            fontSize: 20,
          }}
        />
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            fontWeight: 500,
            flex: 1,
          }}
        >
          {message || 'Processing problem...'}
        </Typography>
      </Box>
    </Paper>
  );
};

export default ProgressInfoBar;
